import { defineComponent as _defineComponent } from 'vue';
import { useDelActivityStakeholderLinkMutation, useDelIroStakeholderLinkMutation, useGetStakeholderQuery, useUpdateStakeholderMutation } from '~/types/types';
export default /*#__PURE__*/_defineComponent({
  __name: 'edit',
  setup: function setup(__props) {
    var route = useRoute();
    var _useGetStakeholderQue = useGetStakeholderQuery(computed(function () {
        return {
          id: route.params.id
        };
      })),
      result = _useGetStakeholderQue.result;
    var item = computed(function () {
      var _result$value;
      return (result === null || result === void 0 ? void 0 : (_result$value = result.value) === null || _result$value === void 0 ? void 0 : _result$value.getStakeholder) || {};
    });
    var _useUpdateStakeholder = useUpdateStakeholderMutation(),
      updateStakeholder = _useUpdateStakeholder.mutate,
      onDone = _useUpdateStakeholder.onDone;
    onDone(function () {
      window.$nuxt.$emit('userMsg');
    });
    var dataTableIro = ref(null);
    var dataTableActivity = ref(null);
    var addIroBtn = ref(null);
    var _useDelIroStakeholder = useDelIroStakeholderLinkMutation(),
      delIroStakeholderLink = _useDelIroStakeholder.mutate,
      delLoading = _useDelIroStakeholder.loading;
    var _useDelActivityStakeh = useDelActivityStakeholderLinkMutation(),
      delActivityStakeholderLink = _useDelActivityStakeh.mutate,
      delActivityLoading = _useDelActivityStakeh.loading;
    return {
      __sfc: true,
      route: route,
      result: result,
      item: item,
      updateStakeholder: updateStakeholder,
      onDone: onDone,
      dataTableIro: dataTableIro,
      dataTableActivity: dataTableActivity,
      addIroBtn: addIroBtn,
      delIroStakeholderLink: delIroStakeholderLink,
      delLoading: delLoading,
      delActivityStakeholderLink: delActivityStakeholderLink,
      delActivityLoading: delActivityLoading
    };
  }
});